import {SantaPresentDeliveryStatus} from "./models";

export const transcribeSantaDeliveryStatus = (deliveryStatus: SantaPresentDeliveryStatus) => {
  switch (deliveryStatus) {
    case "NOT_DELIVERED":
      return "Not Delivered"
    case "MARKED_AS_DELIVERED":
      return "Marked as Delivered"
    case "DELIVERY_CONFIRMED":
      return "Delivery Confirmed"
    case "DELIVERY_DOUBLE_CHECKED":
      return "Delivery Double Checked"
    case "NOTIFICATION_SENT":
      return "Notification was sent"

  }
}

export const lowerCaseAllWordsExceptFirstLetters = (string: string) =>
  string.replaceAll(/\S*/g, word =>
    `${word.slice(0, 1)}${word.slice(1).toLowerCase()}`
  );


export const copyToClipboard = async (text: string) => {
  if (!text) return;
  try {
    if (navigator?.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
    } else {
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
    }
  } catch (e) {
    // noop; we keep UI quiet per simple requirement
  }
};
